import React, { useState } from 'react';
import { Modal, Tabs, Tab, Button } from '../../../../../components';
import type { TaskDetails } from '../../../../../services/scraper';
import { VisitDetailsTab } from './VisitDetailsTab';
import { MapTab } from './MapTab';
import { redirectToConversationsWithKnowledgeBase } from '../../Dashboard/utils/analyticsRedirect';
import { useCampaignVisitsDetails } from '../hooks/useCampaignVisitsDetails';

type CampaignVisitsDetailsModalProps = {
  task: TaskDetails | null;
  open: boolean;
  onClose: () => void;
  excludeCountries?: string[];
};

export const CampaignVisitsDetailsModal: React.FC<
  CampaignVisitsDetailsModalProps
> = ({ task, open, onClose, excludeCountries }) => {
  const [activeTab, setActiveTab] = useState<'visits' | 'map'>('visits');

  const { visits, loading, error, sort, onSort } = useCampaignVisitsDetails(
    task?.demo_url || null,
    open,
    excludeCountries
  );

  if (!task) return null;

  const handleConversationsClick = () => {
    if (task.knowledge_base_id) {
      redirectToConversationsWithKnowledgeBase({
        knowledgeBaseId: task.knowledge_base_id,
      });
    }
  };

  const modalTitle = (
    <div className="flex flex-col">
      <span className="font-bold text-mainText text-section">
        {task.campaign_name || 'Campaign Details'}
      </span>
      {task.url && (
        <span className="text-small text-secondary mt-1 break-all">
          {task.url}
        </span>
      )}
    </div>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={modalTitle}
      size="medium"
      contentClassName="p-0"
    >
      {task.knowledge_base_id && (
        <div className="px-6 py-4 flex justify-start">
          <Button
            label="Show Conversations"
            onClick={handleConversationsClick}
            size="small"
          />
        </div>
      )}
      <Tabs<'visits' | 'map'>
        tabs={[
          { name: 'visits', label: 'Visit Details' },
          { name: 'map', label: 'Map' },
        ]}
        activeTab={activeTab}
        onChange={setActiveTab}
        contentClassName="p-6"
      >
        <Tab name="visits">
          <VisitDetailsTab
            visits={visits}
            loading={loading}
            error={error}
            sort={sort}
            onSort={onSort}
          />
        </Tab>
        <Tab name="map">
          <MapTab visits={visits} />
        </Tab>
      </Tabs>
    </Modal>
  );
};
